import { render, staticRenderFns } from "./StandartsCatalogGroupPage.vue?vue&type=template&id=760d87b8&"
import script from "./StandartsCatalogGroupPage.vue?vue&type=script&lang=js&"
export * from "./StandartsCatalogGroupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports